export const API_BASE_URL = "http://localhost:3500";
// export const API_BASE_URL = "https://server-2-wlpk.onrender.com";



export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};
